const Management = () => {
  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Руководство</h2>
      <p><strong>ИП Благодатская Ю.Ю.</strong></p>
      <p>Телефон: 8-962-177-70-75</p>
      <p>Email: Blagodatskaya-yu@mail.ru</p>
    </div>
  );
};

export default Management;
